import { render, staticRenderFns } from "./_NotifReminder.vue?vue&type=template&id=b469cf90&scoped=true&"
import script from "./_NotifReminder.vue?vue&type=script&lang=js&"
export * from "./_NotifReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b469cf90",
  null
  
)

export default component.exports